<template>
  <div class="discord-widget">
    <div class="container fluid py-2" v-if="!loading && model">
      <div class="layout py-2 align-center justify-space-between row">
        <div class="discord-logo">
          <img
            height="24"
            width="83"
            src="@/assets/img/logo_discord.svg"
            alt="discord-logo"
          />
        </div>
        <div class="discotrd-online-count">
          <b>{{ members.length }}</b> Members Online
        </div>
      </div>
      <div class="divider"></div>
      <simplebar class="discord-content">
        <div class="layout column my-1">
          <div class="discord-channels">
            <div
              class="discord-channel py-1 layout align-center justify-space-between row"
              v-for="ch in channels"
              :key="ch.id"
            >
              {{ ch.name }}
            </div>
          </div>
          <div class="discord-members-online my-1 py-1">
            <div class="title">Members Online</div>
            <div
              class="discord-member py-1 layout align-center justify-space-between row"
              v-for="member in members"
              :key="member.id"
            >
              <div class="discord-member__name ellipsis">
                <div
                  :style="{
                    backgroundColor: `${colors[member.id % colors.length]}`,
                    backgroundImage: `url('${member.avatar_url}')`
                  }"
                  class="discord-member__ava"
                ></div>
                <span>{{ member.username }}</span>
              </div>
              <div class="discord-member__info ellipsis">
                <span v-if="member.game">{{ member.game.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </simplebar>
      <div class="divider"></div>
      <div class="layout py-2 align-center justify-space-between row">
        <span>Free voice chat from Discord</span>

        <app-btn
          :href="model.invite_url"
          target="_blank"
          outline
          class="discord-connect"
          >Connect</app-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import simplebar from "simplebar-vue";
import discordService from "@/services/discord";
import sortBy from "lodash/sortBy";

export default {
  components: { simplebar },
  data: () => ({
    loading: false,
    model: null,
    colors: [
      "#E72F31",
      "#7CD7FF",
      "#FBC33E",
      "#1480B2",
      "#34C94C",
      "#565656",
      "#DB25DF"
    ]
  }),

  computed: {
    channels() {
      let { channels } = this.model || {};
      return channels ? sortBy(channels, ["position"]) : [];
    },
    members() {
      let { members } = this.model || [];
      return members.filter(o => o.status == "online");
    }
  },

  methods: {
    async fetchData() {
      if (this.loading) return;
      this.loading = true;

      this.model = await discordService.getServerInfo();
      this.$nextTick(() => {
        this.loading = false;
      });
    }
  },

  created() {
    this.fetchData();
  }
};
</script>

<style lang="scss">
.discord-connect {
  font-weight: normal !important;
  text-transform: none;
  height: auto;
  padding: 8px 16px;
  font-size: 10px;
  line-height: 14px;
  color: rgba(#fff, 0.5);

  &:hover {
    border-color: #fff;
    background-color: #fff;
    color: invert(rgba(#fff, 0.8));
  }
}

.discord-widget {
  width: 300px;
  max-height: 404px;
  font-family: "Open Sans", sans-serif !important;
  font-style: normal !important;
  background: rgba(#000a25, 0.6);
  border-radius: 6px;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.02em;
  color: rgba(#fff, 0.5);

  @include breakpoint("xs-only") {
    width: 100%;
    margin-bottom: 20px;
  }

  .layout {
    margin: 0 !important;
  }
}

.discord-content {
  max-height: 300px;
  overflow: hidden;
  overflow: auto;
}

.discord-logo {
  img {
    display: block;
  }
}

.discord-channels {
  font-weight: 800;
  font-size: 12px;
  line-height: 16px;
}

// .discord-channel { }

.discord-members-online {
  .title {
    font-weight: 800;
    font-size: 12px !important;
    line-height: 16px !important;
    text-align: left;
    color: #1480b2;
    text-transform: uppercase;
  }
}

.discord-member {
  padding: 0 8px;

  &__name {
    max-width: 50%;
  }
  &__info {
    max-width: 40%;
  }
  &__name,
  &__info {
    span {
      vertical-align: middle;
      // display: inline-block;
    }
  }
  &__ava {
    vertical-align: middle;
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    margin-right: 10px;
    background-size: cover;

    img {
      display: block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
    }
  }
}
</style>
